import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraIconTile } from '../ensigns/icon-tile';
import { SpecraSurface } from '../ensigns/surface';
import { SpecraHeading, SpecraText } from '../ensigns/typography';
/** Generated file/diagram/report card embedded in a conversation or activity feed. */ export function SpecraArtifactCard({ actions, className, description, icon, preview, title, ...props }) {
    return /*#__PURE__*/ _jsxs(SpecraSurface, {
        className: cn('overflow-hidden', className),
        elevation: "xs",
        ...props,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3 border-b border-border px-4 py-3",
                children: [
                    icon ? /*#__PURE__*/ _jsx(SpecraIconTile, {
                        tone: "info",
                        children: icon
                    }) : null,
                    /*#__PURE__*/ _jsxs("div", {
                        className: "min-w-0 flex-1",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraHeading, {
                                className: "truncate",
                                size: "sm",
                                children: title
                            }),
                            description ? /*#__PURE__*/ _jsx(SpecraText, {
                                className: "block truncate",
                                size: "micro",
                                tone: "muted",
                                children: description
                            }) : null
                        ]
                    }),
                    actions ? /*#__PURE__*/ _jsx("div", {
                        className: "flex shrink-0 gap-1",
                        children: actions
                    }) : null
                ]
            }),
            preview ? /*#__PURE__*/ _jsx("div", {
                className: "bg-muted/30 p-4",
                children: preview
            }) : null
        ]
    });
}
